// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comuna-label {
    cursor: default !important;
    /* Forzar cursor predeterminado */
}



.leaflet-pane .leaflet-iterative {
    cursor: default !important;
    /* Asegura que todo el mapa tenga cursor por defecto */
}

.comuna-title {
    padding: 0 !important;
    color: #001F29;
    font-family: Roboto;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.15px;
}

.divisor {
    border-bottom: 1px solid #C0C8CC;
    margin: 0.75rem 0;
}

.rows-map {
    max-height: 10.25rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: #40484C
}

.comuna-info-tooltip div {
    padding: 0.0625rem 0;
}

.heatmap-map-wrapper .leaflet-popup-pane {
    z-index: 1100;
}

.comuna-info-tooltip-wrapper {
    font-family: 'Roboto';
    font-size: 0.8125rem;
    line-height: 1.4;
    width: 16.25rem;
    max-width: 16.25rem;
    white-space: normal;
    word-wrap: break-word;
}

.comuna-info-modal-backdrop {
    position: absolute;
    inset: 0;
    z-index: 1300;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
}

.comuna-info-modal {
    position: relative;
    width: 90%;
    max-width: 20rem;
    max-height: 80%;
    overflow-y: auto;
    background: white;
    border-radius: 0.75rem;
    padding: 1.5rem 1rem;
    font-family: 'Roboto';
    font-size: 0.8125rem;
    line-height: 1.4;
    animation: comuna-modal-fade 0.2s ease-out;
}

.comuna-info-modal-close {
    position: absolute;
    top: 0.5rem;
    right: 0.75rem;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
    color: #40484C;
}

@keyframes comuna-modal-fade {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@media (max-width: 904px) {
    .comuna-info-modal {
        width: calc(100% - 32px);
        max-width: none;
        max-height: 85%;
    }

    .rows-map {
        max-height: 85%;
    }

    @keyframes comuna-sheet-expand {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Maps/styles.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;;;AAIA;IACI,0BAA0B;IAC1B,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI;YACI,2BAA2B;QAC/B;;QAEA;YACI,wBAAwB;QAC5B;IACJ;AACJ","sourcesContent":[".comuna-label {\n    cursor: default !important;\n    /* Forzar cursor predeterminado */\n}\n\n\n\n.leaflet-pane .leaflet-iterative {\n    cursor: default !important;\n    /* Asegura que todo el mapa tenga cursor por defecto */\n}\n\n.comuna-title {\n    padding: 0 !important;\n    color: #001F29;\n    font-family: Roboto;\n    font-weight: 500;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    letter-spacing: 0.15px;\n}\n\n.divisor {\n    border-bottom: 1px solid #C0C8CC;\n    margin: 0.75rem 0;\n}\n\n.rows-map {\n    max-height: 10.25rem;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    color: #40484C\n}\n\n.comuna-info-tooltip div {\n    padding: 0.0625rem 0;\n}\n\n.heatmap-map-wrapper .leaflet-popup-pane {\n    z-index: 1100;\n}\n\n.comuna-info-tooltip-wrapper {\n    font-family: 'Roboto';\n    font-size: 0.8125rem;\n    line-height: 1.4;\n    width: 16.25rem;\n    max-width: 16.25rem;\n    white-space: normal;\n    word-wrap: break-word;\n}\n\n.comuna-info-modal-backdrop {\n    position: absolute;\n    inset: 0;\n    z-index: 1300;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.35);\n}\n\n.comuna-info-modal {\n    position: relative;\n    width: 90%;\n    max-width: 20rem;\n    max-height: 80%;\n    overflow-y: auto;\n    background: white;\n    border-radius: 0.75rem;\n    padding: 1.5rem 1rem;\n    font-family: 'Roboto';\n    font-size: 0.8125rem;\n    line-height: 1.4;\n    animation: comuna-modal-fade 0.2s ease-out;\n}\n\n.comuna-info-modal-close {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.75rem;\n    background: transparent;\n    border: none;\n    font-size: 1.25rem;\n    line-height: 1;\n    cursor: pointer;\n    color: #40484C;\n}\n\n@keyframes comuna-modal-fade {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@media (max-width: 904px) {\n    .comuna-info-modal {\n        width: calc(100% - 32px);\n        max-width: none;\n        max-height: 85%;\n    }\n\n    .rows-map {\n        max-height: 85%;\n    }\n\n    @keyframes comuna-sheet-expand {\n        from {\n            transform: translateY(100%);\n        }\n\n        to {\n            transform: translateY(0);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
